// Shared easing: a fast-out, long-settle curve (expo-out-ish) -- the
// difference between "animated" and "expensive-feeling" is mostly this.
export const EASE = [0.16, 1, 0.3, 1] as const
